function UnitedArabEmirates({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2430)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M9.04346 21.5654L10.4348 31.0052C12.168 31.6484 14.0428 32.0002 16 32.0002C22.8793 32.0002 28.7441 27.6582 31.0047 21.5654H9.04346Z" fill="black"/>
  <path d="M9.04346 10.4348L10.4348 0.995062C12.168 0.351875 14.0428 0 16 0C22.8793 0 28.7441 4.342 31.0047 10.4348H9.04346Z" fill="#6DA544"/>
  <path d="M0 15.9999C0 22.8794 4.34206 28.7441 10.4348 31.0047V0.995117C4.34206 3.2558 0 9.12049 0 15.9999Z" fill="#A2001D"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default UnitedArabEmirates;
